/**
 * Get function name and parameters
 * @param {String} input
 * @returns {FunctionDataProps}
 */
const getFunctionData = (input) => {
  const map = new Map();
  const isComposition = /^◖/.test(input);
  const isPriority = /^!/.test(input);

  if (isComposition) {
    map.set("composition", input.slice(1, 2));
    input = input.slice(3);
  }
  if (isPriority) {
    input = input.slice(1);
  }

  map.set("priority", isPriority);
  map.set("is-composition", isComposition);

  if (input.includes("(") && /^(\.|\w|--)(.*?)\)$/g.test(input)) {
    const name = input.slice(0, input.indexOf("("));
    const parameters = input.slice(input.indexOf("(") + 1, -1);

    map.set("name", name);
    map.set("parameters", parameters);
    map.set("is-fn", true);

    return map;
  } else {
    map.set("name", input);
    map.set("parameters", null);
    map.set("is-fn", false);

    return map;
  }
};

export default getFunctionData;
